import { createFileRoute } from '@tanstack/react-router'
import { FinanceProductsPage } from '_/features/finance/ui/pages/finance-products-page'

export const Route = createFileRoute('/_authenticated/finance/products')({
	staticData: { title: 'finance_products_title' },
	component: FinanceProductsPage,
})
